import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-276874f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createStaticVNode("<div class=\"subtitle\" data-v-276874f4>账号注册</div><div class=\"content-style align-items\" data-v-276874f4><div class=\"img-box\" data-v-276874f4><img class=\"clock-style\" src=\"https://static.ebtech.com/customer-service.jpeg\" alt=\"\" data-v-276874f4></div><div class=\"des-style mt-36\" data-v-276874f4> 我们将尽快完成审核，并通过短信通知审核结果； </div><div class=\"des-style\" data-v-276874f4> 微信扫描上方二维码添加您的专属客服，加速审核。 </div></div>", 2);
const _hoisted_3 = /*#__PURE__*/ _createTextVNode("返回");
const _hoisted_4 = { class: "sign-bottom" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "已有账号？", -1));
import { useLogin } from "./hooks";
export default /*#__PURE__*/ _defineComponent({
    name: 'SignupNotify',
    setup(__props) {
        const { changeState } = useLogin();
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                _createVNode(_component_el_button, {
                    class: "login-btn",
                    size: "large",
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(changeState)('login')))
                }, {
                    default: _withCtx(() => [
                        _hoisted_3
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("span", {
                        class: "aStyle",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(changeState)('login')))
                    }, "立即登录")
                ])
            ]));
        };
    }
});
